import { render, staticRenderFns } from "./qingshuTable.vue?vue&type=template&id=0c8df08e&scoped=true"
import script from "./qingshuTable.vue?vue&type=script&lang=js"
export * from "./qingshuTable.vue?vue&type=script&lang=js"
import style0 from "./qingshuTable.vue?vue&type=style&index=0&id=0c8df08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8df08e",
  null
  
)

export default component.exports